module.exports = require("lodash/toUpper");